import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { PropsWithChildren, ReactElement } from "react"
import { FormattedNumber } from "react-intl"
import NumericLabel from "react-pretty-numbers"
import "./statbox.scss"

interface OwnProps {
    id: string
    className?: string | undefined
    activeClassName?: string | undefined
    colorStyle?: string
    label: ReactElement
    count: number | string
    amount: number | string
    selected?: boolean
    isDashboard?: boolean
    isEditable?: boolean
    onChange: (id: string) => void
}

const StatBox = (props: PropsWithChildren<OwnProps>) => {
    const isActive = props.selected && !props.isDashboard
    const className = `click-stats-box ${props.className} ${isActive ? props.activeClassName ?? "active-box" : ""}`
    const numberLabel = {
        justification: "L",
        locales: AppContext.getLocale().getLanguage(),
        currency: true,
        currencyIndicator: AppContext.getCurrency(),
        percentage: false,
        precision: 0,
        commafy: false,
        shortFormat: true,
        title: true,
    }

    return (
        <div className={props.isDashboard ? "" : "col-sm-12 col-md-3"}>
            <div className="row">
                <div className="py-1 col-12 flex">
                    <div
                        className={className}
                        onClick={() => props.onChange(props.selected ? "" : props.id)}
                        style={{ cursor: "pointer"}}
                    >
                        <div className={(props.isDashboard && props.isEditable && "shortcut-filter") + " dashboard-stats-box"}>
                            <div className="dashboard-stats-desc text-center text-truncate ">
                                {props.children}
                                {props.label}
                                &nbsp;
                                <FormattedNumber
                                    value={props.count}
                                />
                            </div>
                            <div className={`dashboard-stat-value ${props.colorStyle}`}>
                                <h1 className="m-0 p-0">
                                    <NumericLabel params={numberLabel}>
                                        {props.amount}
                                    </NumericLabel>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StatBox


// WEBPACK FOOTER //
// ./src/common/listing/statbox.tsx